import axiosInstance from "./axiosService";

export interface AuthResponse {
  status: string;
  message: string;
  token: string;
  user?: any;
  connected_clinic: any;
}


// Login function
export const login = async (username: string, password: string) => {
  const response = await axiosInstance.post("account/login/", { username, password });
  return response.data;
};

export const logout = async () => {
  const response = await axiosInstance.post("account/logout/", null, {
    withCredentials: true,
  });
  return response.data;
};

// Signup function
export const signup = async (email: string, password: string) => {
  const response = await axiosInstance.post("account/signup", { email, password });
  return response.data;
};

// Refresh token function
export const refreshToken = async () => {
  const response = await axiosInstance.post("account/token/refresh");
  return response.data;
};

